import { render, staticRenderFns } from "./TableCustom.vue?vue&type=template&id=4cc48156&scoped=true&"
import script from "./TableCustom.vue?vue&type=script&lang=js&"
export * from "./TableCustom.vue?vue&type=script&lang=js&"
import style0 from "./TableCustom.vue?vue&type=style&index=0&id=4cc48156&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc48156",
  null
  
)

export default component.exports